import { createContext, useContext } from "react";

/**
 * Signalisiert eingebetteten Formularen, dass sie gerade als VOLLSEITE
 * (Window-State `"page"`) dargestellt werden — und nicht in einem schwebenden
 * oder maximierten Fenster.
 *
 * Gebraucht wird das für die untere Schritt-Leiste: im Fenster richtet sie sich
 * nach der Inhaltsspalte (max. 880px), in der Vollseite läuft sie über die
 * volle Breite am unteren Rand. Bewusst ein Context statt einer Prop durch acht
 * Step-Formulare: der Provider steht an genau einer Stelle (RiskFormWindow),
 * der Konsument ebenfalls (BottomBar). Der Default `false` hält alle übrigen
 * BottomBar-Nutzer (Vertragsanlage, Kennzahlen, öffentliches Formular)
 * unverändert.
 */
export const PageChromeContext = createContext(false);

/** True, wenn das Formular gerade als Vollseite dargestellt wird. */
export const useIsPageChrome = (): boolean => useContext(PageChromeContext);
